import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import { MuiIcons } from "../../../utils";
import clsx from "classnames";
import PropTypes from "prop-types";

// const buttonStyle = {
//     backgroundColor: "#0B72B9",
//     outline: "none",
//     color: "white",
//     border: "none",
//     borderRadius: "0px"
// };

const BActionButton = ({
    title,
    type,
    onClick,
    size,
    isEdit,
    isSubmitting,
    icon,
    className,
    style,
    ...props
}) => {
    const baseClass = clsx("mb-0 my-2 shadow-none", "b-custom-button2", className);
    return (
        <Fragment>
            <Button
                type={type}
                className={baseClass}
                block
                onClick={onClick}
                variant={"primary"}
                style={{  ...style }}
                size={size}
                {...props}
            >
                {isSubmitting ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <span
                            className="spinner-border spinner-border-sm mr-1 text-white "
                            role="status"
                        />
                        <span>Loading...</span>
                    </div>
                ) : (
                    <>
                        {icon && <span className={"mr-1"}>{MuiIcons[icon]}</span>} &nbsp;
                        {isEdit ? "UPDATE" : title}
                    </>
                )}
            </Button>
        </Fragment>
    );
};

BActionButton.defaultProps = {
    onClick: undefined,
    size: "sm",
    isEdit: false,
    isSubmitting: false,
    title: "SUBMIT",
    style: {},
    icon: "send",
    type: "submit",
    className: ""
};

BActionButton.propTypes = {
    size: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.oneOf(Object.keys(MuiIcons)),
    type: PropTypes.string,
    isEdit: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    style: PropTypes.object
};

export default BActionButton;

// style={Object.assign({},buttonStyle,style)}
